.shift-rules {
  //font-weight: bold;

  a {
    font-weight: bold;
    display: block;
  }

}
